import { TableContainer } from '@mui/material';

import { FilesCardTable } from 'Lib/components/common/table/index';
import { TableCard } from 'Lib/muiComponents/common/cards/index';
import { screenSize } from 'Lib/utilities/screenSize';

import EmptyView from './EmptyView';

/**
 * CardTable component to render data in a card layout.
 *
 * Props:
 * - `files`: Boolean indicating if the table is for files.
 * - `data`: Array of data objects for the table.
 * - `breadcrumbs`: Array of breadcrumb objects for navigation.
 * - `emptyMessage`: String for the message displayed when no data is present.
 * - `emptyIcon`: String for the icon displayed when no data is present.
 * - `emptyFlair`: String for the flair icon displayed when no data is present.
 * - ...otherProps: Additional props spread into the table.
 */

export default function CardTable({ files, ...props }) {
    const isEmpty = props.data.length === 0;
    const TableComponent = files ? FilesCardTable : TableCard;
    const { smallMobile, mobile } = screenSize();

    return (
        <TableContainer
            elevation={0}
            sx={{
                overflow: files ? 'hidden' : 'unset',
                height: '100%',
                width: files ? `calc(100% + ${mobile ? '16' : '32'}px)` : '100%',
                mb: files && !smallMobile ? -4 : 0,
                ml: files ? -4 : 0,
                mr: files && mobile ? -4 : 0
            }}
        >
            {isEmpty && !props.loading ? (
                <EmptyView
                    grow
                    title={files && props.breadcrumbs.length > 1 ? 'This folder is empty.' : props.emptyMessage}
                    iconFlair={props.emptyFlair}
                    iconName={props.emptyIcon}
                />
            ) : (
                <TableComponent {...props} />
            )}
        </TableContainer>
    );
}
